import React, { useEffect, type JSX } from 'react';
import { useVorgangContext } from '../contexts/vorgangContext';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../hooks/useUser';
import { signOut } from '../shared/Auth';
import { clearSessionItems } from '../shared/storage';

export function LogoutPage(): JSX.Element {
  const navigate = useNavigate();

  const { hatAenderungen, setzeVorgang } = useVorgangContext();
  const { resetUser } = useUser();

  useEffect(() => {
    if (!hatAenderungen) {
      navigate('/dashboard', { replace: true });
    }

    return () => {
      if (!hatAenderungen) {
        signOut().then(() => {
          setzeVorgang();
          resetUser();
          clearSessionItems();
        });
      }
    };
  }, [hatAenderungen, navigate, setzeVorgang, resetUser]);

  return <>abmelden...</>;
}
